import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "low-budget-ticker" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "ticker-name" }

import { computed } from 'vue';

// Keep in sync with the CSS below
const ENTER_MS = 400;
const LEAVE_MS = 200;
const STAGGER_MS = 40;


export default {
  __name: 'LowBudgetTicker',
  props: {
  /** Students on the current page (up to 6: two columns of three), in display order. */
  students: {
    type: Array,
    required: true,
  },
  /** Changes whenever the page changes, to trigger the swap transition. */
  pageKey: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const rows = computed(() => props.students.map((student, index) => ({
  id: student.id,
  shortName: `${student.lastname},${student.firstname ? ` ${student.firstname.charAt(0)}.` : ''}`,
  title: `${student.firstname} ${student.lastname} (${student.studentId})`,
  available: student.budget.available,
  isNegative: student.budget.available < 0,
  // Stagger follows reading order: down the first column, then the second
  style: { '--row-index': index },
})));

// Transitions run on the rows, not on the <ul>, so Vue can't detect the timing itself
const transitionDuration = computed(() => ({
  enter: ENTER_MS + Math.max(props.students.length - 1, 0) * STAGGER_MS,
  leave: LEAVE_MS,
}));

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Old and new page share one grid cell, so they crossfade in place "),
    _createVNode(_Transition, {
      name: "ticker-page",
      duration: transitionDuration.value
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("ul", {
          key: __props.pageKey,
          class: "ticker-page"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
            return (_openBlock(), _createElementBlock("li", {
              key: row.id,
              class: "ticker-row",
              style: _normalizeStyle(row.style),
              title: row.title
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(row.shortName), 1 /* TEXT */),
              _createElementVNode("span", {
                class: _normalizeClass(["ticker-available", { 'text-danger': row.isNegative }])
              }, _toDisplayString(row.available), 3 /* TEXT, CLASS */)
            ], 12 /* STYLE, PROPS */, _hoisted_2))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["duration"])
  ]))
}
}

}